import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

export const checkin = ({ event: { data: { kind } } }) =>
  <div className={kind}>
    Installer has {kind === 'arrived' ? 'arrived at' : 'left'} Jobsite
  </div>;

checkin.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      kind: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/checkin.jsx